<template>
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/package_rule/pageNotMatchMaterial" getKey="rows" :fixContainerHeight="fixContainerHeight"
                   :columns="columnsCreate" @selectionChange="handleSelectionChange" @select="handleSelect" @selectAll="handleSelectAll">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('baozhuangguizebianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baozhuangguizemingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain" :loading="yt.loading">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({materialId:$attrs.materialId})" :loading="yt.loading">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>

</template>

<script>
export default {
  name: "web_base_matter_matter_package_rule_create",
  data(){
    return {
      columnsCreate: [
        { label: '',type: 'selection', width: 30},
        { label: 'baozhuangguizebianma', prop: 'code', width: 180, },
        { label: 'baozhuangguizemingcheng', prop: 'name', width: 180, },
        { label: 'beizhu', prop: 'remark', width: 300, },
        { label: 'chuangjianren', prop: 'createByObject.nickname', width: 180, },
        { label: 'chuangjianshijian', prop: 'createTime',type: 'time', width: 200, },
      ],
      selected: null,
      fixContainerHeight: 1000,
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.materialId = this.$attrs.materialId;
      this.yt.get(1);
    }, 300)
  },
  methods:{
    handleSelectionChange(val) {
      this.selected = val;
    },
    handleSelect(val){
      this.selected = val;
    },
    handleSelectAll(val){
      this.selected = val;
    },
  },
}
</script>

<style scoped>

</style>